export const EDITING_REQUEST_TYPE = {
  CROP: "crop",
  FIELD_SHAPE: "fieldShape",
  FIELD_SPLIT: "fieldSplit",
  FIELD_REDZONE: "fieldRedzone",
} as const;

export type EditingRequestType = (typeof EDITING_REQUEST_TYPE)[keyof typeof EDITING_REQUEST_TYPE];

type CropType = "MAIN" | "COVER" | "UNDERSOWING" | null;

export const EDITING_REQUEST_IDENTIFIERS = {
  FIELD_ID: "fieldId",
  FIELD_CROP_ID: "fieldCropId",
} as const;

export const editingRequestIdentifierMap = {
  [EDITING_REQUEST_TYPE.FIELD_SHAPE]: EDITING_REQUEST_IDENTIFIERS.FIELD_ID,
  [EDITING_REQUEST_TYPE.FIELD_SPLIT]: EDITING_REQUEST_IDENTIFIERS.FIELD_ID,
  [EDITING_REQUEST_TYPE.FIELD_REDZONE]: EDITING_REQUEST_IDENTIFIERS.FIELD_ID,
  [EDITING_REQUEST_TYPE.CROP]: EDITING_REQUEST_IDENTIFIERS.FIELD_CROP_ID,
};

export type AddEditingRequestRequestBody = {
  fieldId: string;
  requestType: EditingRequestType;
  verificationYear: number;
  fieldCropId?: string | null;
  year?: number | null;
  comment?: string | null;
  cropType?: CropType;
};

export type UpdateEditingRequestRequestBody = {
  id: string;
  userComment: string;
};

export type UpdateEditingRequestRequestBodyAdmin = {
  id: string;
  fieldId?: string;
  requestType?: EditingRequestType;
  fieldCropId?: string | null;
  year?: number | null;
  comment?: string | null;
  cropType?: CropType;
  completedAt?: string;
  reviewedAt?: string;
};

export type VerificationEditingRequest = {
  id: string;
  fieldId: string;
  fieldCropId: string | null;
  completedAt: Date | null;
  reviewedAt: Date | null;
  year: number | null;
  comment: string | null;
  userComment: string | null;
  cropType: CropType;
  requestType: EditingRequestType;
  verifierId: string;
  verificationYear: number;
  createdAt: Date;
  updatedAt: Date;
  field?: {
    id: string;
    name: string;
    number: string;
  } | null;
  verifier?: {
    id: string;
    name: string;
  } | null;
};

export type GetVerificationEditingRequestsResponse = VerificationEditingRequest[];
